/* eslint-disable import/no-anonymous-default-export */
import find from 'lodash/find'
import isUndefined from 'lodash/isUndefined'
import toNumber from 'lodash/toNumber'
// import round from 'lodash/round'

export default (characteristic) => {
  let boxUnit = find(characteristic, { productsize: '0' })
  let pieceUnit = {...find(characteristic, { productsize: '0' }), cashunitprice: toNumber(boxUnit?.cashunitprice) / toNumber(boxUnit?.packingsize)}

  if (isUndefined(boxUnit)) {
    boxUnit = {
      barcode: '',
      cashunitprice: 0,
      creditunitprice: 0,
      grossweigth: 0,
      height: 0,
      length: 0,
      netweigth: 0,
      packingsize: 0,
      productcode: 0,
      productsize:0,
      width: 0,
    }
  }

  if (isUndefined(pieceUnit)) {
    pieceUnit = {
      barcode: '',
      cashunitprice: 0,
      creditunitprice: 0,
      grossweigth: 0,
      height: 0,
      length: 0,
      netweigth: 0,
      packingsize: 0,
      productcode: 0,
      productsize:9,
      width: 0,
    }
  }

  return { boxUnit, pieceUnit }
}